<template>
  <a-modal
    title="新建"
    style="top: 20px;"
    :width="1200"
    v-model="visible"
    :confirmLoading="confirmLoading"
    @ok="handleSubmit"
    @cancel="handleClose"
    :maskClosable="false"
    :footer="false"
  >
    <div class="table-page-search-wrapper">
      <a-form :form="form" layout="inline" style="margin-left: 30px" @submit="handleSubmit">
        <div style="margin-bottom: 30px">
          <span style="color: deepskyblue;font-size: 20px;">基本信息 :</span>
          <!--<span style="padding:3px 15px;border:1px solid #aaa;border-radius:50% / 50%;margin-left:10px" >实名认证</span>-->
          <!--<span style="padding:3px 22px;border:1px solid #aaa;border-radius:50% / 50%;margin-left:10px" >保证金</span>-->
        </div>
        <a-row :gutter="16">
          <a-col :span="6">
            <a-form-item label="姓名" :labelCol="labelCol" :wrapperCol="wrapperCol" style="margin-left: 28px">
              <!--<a-input v-model="name"  style="width: 230px;"/>-->
              <a-input
                v-decorator="['name', { rules: [{ required: true, message: '请输入姓名!' }] }]"
                autocomplete="off"
                :disabled="isTrueText"
              />
            </a-form-item>
          </a-col>
          <a-col :span="6">
            <a-form-item label="性别" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <!--<a-select v-model="sex"  style="width: 230px;">-->
              <a-select
                v-decorator="['sex', { rules: [{ required: true, message: '请输入性别' }] }]"
                :disabled="isTrueText"
              >
                <a-select-option v-for="type in restaurantTypes7" :key="type.code">{{ type.label }}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :span="6">
            <a-form-item label="用户名" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <!--<a-input v-model="loginName"  style="width: 230px;"/>-->
              <a-input
                v-decorator="[
                  'loginName',
                  { rules: [{ min: 5, max: 20, required: true, message: '请输入5-20位字符!' }] }
                ]"
                autocomplete="off"
              />
            </a-form-item>
          </a-col>
          <a-col :span="6">
            <a-form-item label="密码" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input
                v-decorator="['password', { rules: [{ validator: this.passText, required: true }] }]"
                type="text"
                autocomplete="new-password"
                onfocus="this.type='password'"
              />
            </a-form-item>
          </a-col>
          <a-col :span="6">
            <a-form-item label="联系方式" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <!--<a-input v-model="phonenumber"  style="width: 230px;"/>-->
              <a-input
                v-decorator="['phonenumber', { rules: [{ validator: this.isPhone, required: true }] }]"
                autocomplete="off"
              />
            </a-form-item>
          </a-col>
          <a-col :span="8">
            <a-form-item label="平台使用情况" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <!--<a-select v-model="platformType" style="width: 230px;">-->
              <a-select
                mode="multiple"
                v-decorator="['platformType', { rules: [{ required: true, message: '请输入平台使用情况' }] }]"
                @change="handleChange"
              >
                <a-select-option v-for="type in restaurantTypes6" :key="type.code">{{ type.label }}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :span="10">
            <a-form-item label="接单方式" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <!--<a-select v-model="receiptType"  style="width: 230px;">-->
              <a-select
                mode="multiple"
                v-decorator="['receiptType', { rules: [{ required: true, message: '接单方式' }] }]"
                @change="handleChange1"
              >
                <a-select-option v-for="type in restaurantTypes3" :key="type.code">{{ type.label }}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :span="6" v-if="open1">
            <a-form-item label="单日最大接单量" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input
                v-decorator="['maxReceiveOrder', { rules: [{ required: true, message: '请输入单日最大接单量' }] }]"
                autocomplete="off"
              />
            </a-form-item>
          </a-col>
        </a-row>
        <a-row :gutter="16">
          <a-col :span="18">
            <a-row :gutter="4">
              <a-col :span="7">
                <a-form-item label="注册地址">
                  <a-select
                    v-decorator="['provinceId', { rules: [{ required: true, message: '请选择省' }] }]"
                    @change="haveProvince3"
                  >
                    <a-select-option v-for="type in data1" :key="type.provinceCode"
                      >{{ type.provinceName }}
                    </a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
              <a-col :span="5">
                <a-form-item label="">
                  <a-select
                    v-decorator="['cityId', { rules: [{ required: true, message: '请选择市' }] }]"
                    @change="haveProvince4"
                  >
                    <a-select-option v-for="type in data2" :key="type.cityCode">{{ type.cityName }}</a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
              <a-col :span="5">
                <a-form-item label="">
                  <a-select
                    v-decorator="['districtId', { rules: [{ required: true, message: '请选择区' }] }]"
                    @change="haveProvince5"
                  >
                    <a-select-option v-for="type in data3" :key="type.areaCode">{{ type.areaName }}</a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
              <a-col :span="7">
                <a-form-item label="">
                  <a-input
                    v-decorator="['detailedAddress', { rules: [{ required: true, message: '请输入详情地址' }] }]"
                  />
                </a-form-item>
              </a-col>
            </a-row>
          </a-col>
          <a-col :span="6">
            <a-form-item label="备用联系方式" :labelCol="labelCol" :wrapperCol="wrapperCol" style="margin-left: 26px;">
              <a-input v-decorator="['contactReserve']" autocomplete="off" />
            </a-form-item>
          </a-col>
        </a-row>
        <a-row :gutter="16" style="margin-bottom: 60px">
          <a-col :span="18">
            <a-form-item label="服务类别" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-checkbox-group
                v-decorator="[
                  'installType',
                  { rules: [{ required: true, message: '请输入服务类别' }], initialValue: addd }
                ]"
                style="width: 100%;margin-top:5px;"
                @change="handleCheck11"
              >
                <a-checkbox v-for="type in restaurantTypes1" :value="type.code">
                  {{ type.label }}
                </a-checkbox>
              </a-checkbox-group>
            </a-form-item>
            <a-form-item>
              <a-tabs ref="tabPane" @change="callback2" type="card">
                <a-tab-pane v-for="type in installTabs" :tab="type.label" :key="type.code">
                  <a-form-item label="标签" :labelCol="labelCol" :wrapperCol="wrapperCol" class="redItem">
                    <a-checkbox-group
                      v-decorator="['masterLabel' + '$' + type.code]"
                      style="width: 100%;margin-top:5px;"
                      @change="handleCheck2"
                    >
                      <a-checkbox
                        v-for="item in data4[type.code]"
                        :value="item.installLabelId"
                        :key="type.code + item.installLabelId"
                      >
                        {{ item.installLabelName }}
                      </a-checkbox>
                    </a-checkbox-group>
                  </a-form-item>
                </a-tab-pane>
              </a-tabs>
            </a-form-item>
          </a-col>
          <a-col :span="6">
            <a-form-item label="师傅负责人" :labelCol="labelCol" :wrapperCol="wrapperCol" style="margin-left:28px">
              <a-select v-decorator="['masterLeading', { rules: [{ required: true, message: '请输入师傅负责人' }] }]">
                <a-select-option v-for="type in pullDown" :key="type.userId">{{ type.userName }}</a-select-option>
              </a-select>
            </a-form-item>
            <a-form-item label="角色" :labelCol="labelCol" :wrapperCol="wrapperCol" style="margin-left: 70px;">
              <a-select v-decorator="['roleIds', { rules: [{ required: true, message: '请选择角色' }] }]">
                <a-select-option v-for="type in roleAll" :key="type.roleId">{{ type.roleName }}</a-select-option>
              </a-select>
            </a-form-item>
            <a-form-item label="派单置顶" :labelCol="labelCol" :wrapperCol="wrapperCol" style="margin-left:52px">
              <a-select v-decorator="['isTop']" allowClear="true">
                <a-select-option value="0">
                  不是
                </a-select-option>
                <a-select-option value="1">
                  是
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
        </a-row>
        <div style="margin-bottom: 20px">
          <span style="color: deepskyblue;font-size: 20px;">师傅档案 :</span>
        </div>
        <a-row :gutter="16">
          <a-col :span="6">
            <a-form-item label="师傅类型" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <!--<a-select v-model="workerType" style="width: 230px;">-->
              <a-select v-decorator="['workerType', { rules: [{ required: true, message: '请输入师傅类型' }] }]">
                <a-select-option v-for="type in restaurantTypes" :key="type.code">{{ type.label }}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :span="6">
            <a-form-item style="margin-left: 16px" label="师傅等级" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-select v-decorator="['techLevel']">
                <a-select-option v-for="type in restaurantTypes2" :key="type.code" :value="type.code"
                  >{{ type.label }}
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24">
            <a-form-item label="提现方式" style="margin-left: 2px" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <!--<a-select v-model="cashStatus" style="width: 230px;">-->
              <a-select v-decorator="['cashStatus', { rules: [{ required: true, message: '请输入提现方式' }] }]">
                <a-select-option v-for="type in restaurantTypes5" :key="type.code">{{ type.label }}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :span="6">
            <a-form-item label="提现周期" :labelCol="labelCol" :wrapperCol="wrapperCol" style="margin-left: 2px">
              <!--<a-select v-model="cashCycle" style="width: 230px;">-->
              <a-select v-decorator="['cashCycle', { rules: [{ required: true, message: '请输入提现周期' }] }]">
                <a-select-option v-for="type in restaurantTypes4" :key="type.code">{{ type.label }}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
        </a-row>
        <a-row :gutter="16">
          <a-col :span="6">
            <a-form-item label="私密" :labelCol="labelCol" :wrapperCol="wrapperCol" style="margin-left: 40px">
              <a-select v-decorator="['privateMaster']" allowClear="true">
                <a-select-option value="0">
                  不是
                </a-select-option>
                <a-select-option value="1">
                  是
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :span="6">
            <a-form-item style="margin-left: 44px;" label="户名" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input v-decorator="['cardHouseHolder']" autocomplete="off" />
            </a-form-item>
          </a-col>
          <a-col :span="6">
            <a-form-item style="margin-left:14px" label="开户行" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <!--<a-input v-decorator="['cardOrg']"  autocomplete="off"/>-->
              <a-select
                showSearch
                optionFilterProp="children"
                v-decorator="['cardOrg']"
                :filterOption="filterOption"
                allowClear="true"
              >
                <a-select-option v-for="item of bankName" :title="item.name" :key="item.id"
                  >{{ item.name }}
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :span="6">
            <a-form-item label="银行卡账号" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input
                v-decorator="['cardNumber', { rules: [{ validator: this.bankNum, required: false }] }]"
                autocomplete="off"
              />
            </a-form-item>
          </a-col>
        </a-row>
        <a-row :gutter="16">
          <a-col :span="6">
            <a-form-item label="师傅备注" :labelCol="labelCol" :wrapperCol="wrapperCol" style="margin-left: 12px">
              <a-input v-decorator="['masterRemark']" autocomplete="off" />
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24">
            <a-form-item style="margin-left: 16px" label="身份证号" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input
                v-decorator="['idCard', { rules: [{ validator: this.idCards, required: false }] }]"
                autocomplete="off"
                :disabled="isTrueText"
              />
            </a-form-item>
          </a-col>
          <a-col :span="6">
            <a-form-item label="证件有效期">
              <a-range-picker v-decorator="['tiem1']" @change="onChange2" :disabled="isTrueTime" />
            </a-form-item>
          </a-col>
        </a-row>
        <a-row :gutter="24">
          <a-col :span="6">
            <a-form-item label="身份证正面" :labelCol="{ labelCol: { span: 9 }, wrapperCol: { span: 15 } }">
              <div class="clearfix">
                <a-upload
                  :action="uploadUrlb"
                  listType="picture-card"
                  :fileList="fileList1"
                  :headers="headers"
                  @preview="handPreview1"
                  @change="handChange1"
                >
                  <div v-if="fileList1.length < 1">
                    <a-icon type="plus" />
                    <div class="ant-upload-text">身份证正面</div>
                  </div>
                </a-upload>
                <a-modal :visible="previewVisible" :footer="null" @cancel="handCancel1">
                  <img alt="example" style="width: 100%" :src="coverUrl1" />
                </a-modal>
              </div>
            </a-form-item>
          </a-col>
          <a-col :span="6">
            <a-form-item label="身份证背面" :labelCol="{ labelCol: { span: 9 }, wrapperCol: { span: 15 } }">
              <div class="clearfix">
                <a-upload
                  :action="uploadUrlb"
                  listType="picture-card"
                  :fileList="fileList2"
                  :headers="headers"
                  @preview="handPreview2"
                  @change="handChange2"
                >
                  <div v-if="fileList2.length < 1">
                    <a-icon type="plus" />
                    <div class="ant-upload-text">身份证反面</div>
                  </div>
                </a-upload>
                <a-modal :visible="previewVisible" :footer="null" @cancel="handCancel2">
                  <img alt="example" style="width: 100%" :src="coverUrl2" />
                </a-modal>
              </div>
            </a-form-item>
          </a-col>
          <a-col :span="6">
            <a-form-item
              style="margin-left: 10px"
              label="免冠照片"
              :labelCol="{ labelCol: { span: 9 }, wrapperCol: { span: 24 } }"
            >
              <div class="clearfix">
                <a-upload
                  :action="uploadUrlb"
                  listType="picture-card"
                  :fileList="fileList3"
                  :headers="headers"
                  @preview="handPreview3"
                  @change="handChange3"
                >
                  <div v-if="fileList3.length < 1">
                    <a-icon type="plus" />
                    <div class="ant-upload-text">免冠照</div>
                  </div>
                </a-upload>
                <a-modal :visible="previewVisible" :footer="null" @cancel="handCancel3">
                  <img alt="example" style="width: 100%" :src="coverUrl3" />
                </a-modal>
              </div>
            </a-form-item>
          </a-col>
        </a-row>
        <a-row :gutter="24" style="margin-top: 80px">
          <a-col :span="24">
            <a-form-item label="备注" style="width:100%;margin-bottom: 40px">
              <a-textarea v-decorator="['remark']" />
            </a-form-item>
          </a-col>
        </a-row>
        <a-row :span="24" style="margin-top: 40px">
          <a-col :span="9" :offset="8">
            <a-affix :offsetBottom="60">
              <div style="width: 290px;">
                <a-button
                  style="margin-right: 50px;width:120px;float: left"
                  type="primary"
                  html-type="submit"
                  :loading="iconLoading"
                  >提交</a-button
                >
                <a-button style="width:120px;float: left" @click="getClose">取消</a-button>
              </div>
            </a-affix>
          </a-col>
        </a-row>
      </a-form>
    </div>
  </a-modal>
</template>

<script>
import { STable } from '@/components'
import {
  idCardOrc,
  selectFindAll,
  roleAll,
  addMaster,
  getSelectAllProvince,
  getelectCityName,
  getelectAreaName,
  selectInstallTypeAndLabel,
  findByDeptId
} from '@/api/master/MasterList'
import { checkPermission } from '@/utils/permissions'
import { getDictMap } from '../../../utils/dict'
import { ACCESS_TOKEN } from '@/store/mutation-types'
import ACol from 'ant-design-vue/es/grid/Col'
import _ from 'lodash'
import pick from 'lodash.pick'
import moment from 'moment'

export default {
  name: 'MasterlistModal',
  components: {
    ACol
  },
  data() {
    return {
      iconLoading: false,
      visible: false,
      labelCol: {
        xs: { span: 24 },
        sm: { span: 8 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 }
      },
      confirmLoading: false,
      mdl: {},
      form: this.$form.createForm(this),
      roleAll: [],
      restaurantTypes: [],
      restaurantTypes1: [],
      restaurantTypes2: [],
      restaurantTypes3: [],
      restaurantTypes4: [],
      restaurantTypes5: [],
      restaurantTypes6: [],
      restaurantTypes7: [],
      data1: [],
      data2: [],
      data3: [],
      data4: [],
      pullDown: [],
      installTabs: [],
      idStartTime: '',
      idEndTime: '',
      open1: '',
      addd: [],
      tiem1: '',
      isTrueText: false,
      isTrueTime: false,
      // 上传
      headers: {
        token: Vue.ls.get(ACCESS_TOKEN)
      },
      previewVisible: false,
      uploadUrlb: process.env.VUE_APP_API_BASE_URL + '/dfs/upload?type=master',
      bankName: [
        { id: '中国工商银行', name: '中国工商银行' },
        { id: '中国银行', name: '中国银行' },
        { id: '中国建设银行', name: '中国建设银行' },
        { id: '中国农业银行', name: '中国农业银行' },
        { id: '交通银行', name: '交通银行' },
        { id: '中国邮政储蓄银行', name: '中国邮政储蓄银行' },
        { id: '招商银行', name: '招商银行' },
        { id: '上海浦东发展银行', name: '上海浦东发展银行' },
        { id: '民生银行', name: '民生银行' },
        { id: '兴业银行', name: '兴业银行' },
        { id: '中信银行', name: '中信银行' },
        { id: '平安银行', name: '平安银行' },
        { id: '光大银行', name: '光大银行' },
        { id: '华夏银行', name: '华夏银行' },
        { id: '广发银行', name: '广发银行' },
        { id: '上海银行', name: '上海银行' },
        { id: '南京银行', name: '南京银行' },
        { id: '渤海银行', name: '渤海银行' },
        { id: '江苏银行', name: '江苏银行' },
        { id: '恒丰银行', name: '恒丰银行' },
        { id: '徽商银行', name: '徽商银行' },
        { id: '国家开发银行', name: '国家开发银行' },
        { id: '上海农村商业银行', name: '上海农村商业银行' },
        { id: '农村信用社', name: '农村信用社' },
        { id: '农村合作银行', name: '农村合作银行' }
      ],
      fileList1: [],
      fileList2: [],
      fileList3: [],
      coverUrl1: '',
      coverUrl2: '',
      coverUrl3: '',
      picture1: {
        identityType: '',
        identityUrl: ''
      },
      picture2: {
        identityType: '',
        identityUrl: ''
      },
      picture3: {
        identityType: '',
        identityUrl: ''
      },
      identity: [] //上传图片
    }
  },
  beforeCreate() {
    this.form = this.$form.createForm(this)
  },
  async created() {
    selectFindAll({
      dictTypes: 'worker_type,install_type,tech_level,receipt_type,cash_cycle,cash_status,platform_type,sys_user_sex'
    }).then(res => {
      this.restaurantTypes = []
      this.restaurantTypes1 = []
      this.restaurantTypes2 = []
      this.restaurantTypes3 = []
      this.restaurantTypes4 = []
      this.restaurantTypes5 = []
      this.restaurantTypes6 = []
      this.restaurantTypes7 = []
      this.restaurantOperTypeMap = res.worker_type
      this.restaurantOperTypeMap1 = res.install_type
      this.restaurantOperTypeMap2 = res.tech_level
      this.restaurantOperTypeMap3 = res.receipt_type
      this.restaurantOperTypeMap4 = res.cash_cycle
      this.restaurantOperTypeMap5 = res.cash_status
      this.restaurantOperTypeMap6 = res.platform_type
      this.restaurantOperTypeMap7 = res.sys_user_sex
      this.restaurantOperTypeMap.forEach((value, key) => {
        this.restaurantTypes.push({ code: value.dictValue, label: value.dictLabel })
      })
      this.restaurantOperTypeMap1.forEach((value, key) => {
        // console.log(value,key)
        this.restaurantTypes1.push({ code: value.dictValue, label: value.dictLabel })
      })
      this.restaurantOperTypeMap2.forEach((value, key) => {
        // console.log(value,key)
        this.restaurantTypes2.push({ code: value.dictValue, label: value.dictLabel })
      })
      this.restaurantOperTypeMap3.forEach((value, key) => {
        // console.log(value,key)
        this.restaurantTypes3.push({ code: value.dictValue, label: value.dictLabel })
      })
      this.restaurantOperTypeMap4.forEach((value, key) => {
        // console.log(value,key)
        this.restaurantTypes4.push({ code: value.dictValue, label: value.dictLabel })
      })
      this.restaurantOperTypeMap5.forEach((value, key) => {
        // console.log(value,key)
        this.restaurantTypes5.push({ code: value.dictValue, label: value.dictLabel })
      })
      this.restaurantOperTypeMap6.forEach((value, key) => {
        // console.log(value,key)
        this.restaurantTypes6.push({ code: value.dictValue, label: value.dictLabel })
      })
      this.restaurantOperTypeMap7.forEach((value, key) => {
        // console.log(value,key)
        this.restaurantTypes7.push({ code: value.dictValue, label: value.dictLabel })
      })
    })
    getSelectAllProvince().then(res => {
      // console.log(res)
      this.data1 = res.rows
    })
    // 师傅负责人
    findByDeptId().then(res => {
      // console.log(res)
      this.pullDown = res
    })
  },
  methods: {
    moment,
    filterOption(input, option) {
      return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
    },
    add() {
      this.addd = []
      this.installTabs = []
      this.form.resetFields()
      this.data2 = []
      this.data3 = []
      this.visible = true
      this.open1 = false
      this.$nextTick(() => {
        this.form.setFieldsValue({
          receiptType: ['1'],
          techLevel: '3',
          sex: '0',
          cashCycle: '1',
          cashStatus: '1',
          platformType: ['2'],
          workerType: '1'
        })
        // 标签
        selectInstallTypeAndLabel().then(res => {
          this.data4 = res.data
        })
        roleAll().then(res => {
          console.log(res)
          this.roleAll = res.rows
        })
      })
    },
    callback2(key) {
      this.$nextTick(() => {
        this.$refs['tabPane'].activeKey = key
      })
    },
    //身份证正则表达式
    idCards(rule, value, callback) {
      const pwdRegex = /^[1-9]\d{5}(18|19|([23]\d))\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/
      if (value == undefined || value.length == 0) {
        callback()
      } else if (!pwdRegex.test(value)) {
        callback(new Error('请输入正确的身份证格式'))
      } else {
        console.log('jinru')
        callback()
      }
    },
    //手机号正则表达式
    isPhone(rule, value, callback) {
      const pwdRegex = /^((0\d{2,3}(-)?\d{7,8})|(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8})$/
      if (value == undefined || value.length == 0) {
        callback(new Error('请输入联系方式'))
      } else if (!pwdRegex.test(value)) {
        callback(new Error('请输入正确的联系方式'))
      } else {
        callback()
      }
    },
    //用户名正则表达式
    // userText (rule, value, callback) {
    //   const pwdRegex =/^\w{5,20}$/
    //   if(value==undefined||value.length == 0){
    //     callback(new Error('请输入用户名'))
    //   }else if (!pwdRegex.test(value)) {
    //     callback(new Error('请输入5到20位(字母,数字,下划线)'))
    //   }else{
    //     callback()
    //   }
    // },
    //密码正则表达式
    passText(rule, value, callback) {
      // const pwdRegex =/^[a-zA-Z0-9_-]{6,20}$/
      const pwdRegex = /^(?=.*[a-zA-Z])(?=.*\d)(?=.*[~!@#$%^&*()_+`\-={}:";'<>?,.\/]).{8,64}$/
      if (value == undefined || value.length == 0) {
        callback(new Error('请输入密码'))
      } else if (!pwdRegex.test(value)) {
        callback(new Error('请输入8位以上密码，必须包含数字、字母、英文特殊字符'))
      } else {
        callback()
      }
    },
    //银行卡号正则表达式
    bankNum(rule, value, callback) {
      const pwdRegex = /^([1-9]{1})(\d{15}|\d{16}|\d{17}|\d{18})$/
      if (value == undefined || value.length == 0) {
        callback()
      } else if (!pwdRegex.test(value)) {
        callback(new Error('请输入正确的银行卡号'))
      }
      callback()
    },
    // 服务类别
    handleCheck11(values) {
      // console.log(values)
      this.installTabs = []
      let that = this
      let arr = this.restaurantTypes1
      for (var j = 0; j < values.length; j++) {
        for (var i = 0; i < arr.length; i++) {
          // console.log(arr[i],values[j])
          if (arr[i].code == values[j]) {
            let isList = {}
            isList.code = arr[i].code
            isList.label = arr[i].label
            this.installTabs.push(isList)
          }
        }
      }

      this.$nextTick(() => {
        if (this.installTabs.length > 0) {
          this.$refs['tabPane'].activeKey = this.installTabs[this.installTabs.length - 1].code
        }
      })
      // console.log(this.installTabs)
      // this.installTabs = values
    },
    handleCheck2(values) {
      // console.log(values)
    },
    onChange2(date, dateString) {
      // console.log('Selected Time: ', date);
      // console.log('Formatted Selected Time: ', dateString);
      this.idStartTime = dateString[0]
      this.idEndTime = dateString[1]
    },
    // 省市区下拉
    haveProvince3(value) {
      // console.log(value)
      this.data2 = []
      this.data3 = []
      this.form.setFieldsValue({ cityId: undefined, districtId: undefined, detailedAddress: '' })
      getelectCityName({ provinceCode: value }).then(res => {
        // console.log(res)
        this.data2 = res.rows
      })
    },
    haveProvince4(value) {
      this.data3 = []
      this.form.setFieldsValue({ districtId: undefined, detailedAddress: '' })
      getelectAreaName({ cityCode: value }).then(res => {
        // console.log(res)
        this.data3 = res.rows
      })
    },
    haveProvince5() {
      this.form.setFieldsValue({ detailedAddress: '' })
    },
    handleChange(value) {
      // console.log(`selected ${value}`);
    },
    handleChange1(value) {
      // console.log(`selected ${value}`);
      if (value.includes('2')) {
        this.open1 = true
      } else {
        this.open1 = false
      }
    },
    // 上传1
    handChange1({ fileList }) {
      this.fileList1 = fileList
      console.log(this.fileList1)
      this.coverUrl1 = fileList[0].response.url
      this.picture1.identityType = 0
      this.picture1.identityUrl = this.coverUrl1
      if (fileList[0].status == 'done') {
        let url =
          process.env.VUE_APP_API_BASE_URL +
          '/dfs/download?fileName=' +
          fileList[0].response.url +
          '&token=' +
          Vue.ls.get(ACCESS_TOKEN)
        idCardOrc({ identityUrl: url, identityType: 0 }).then(res => {
          // console.log(res)
          if (res.code == 0) {
            if (res.data.riskType != 'unknown') {
              this.form.setFieldsValue({
                name: res.data.name,
                sex: res.data.sex == '女' ? '1' : '0',
                idCard: res.data.cardNum
              })
              this.isTrueText = true
            }
          }
        })
      }
      if (fileList.length == 0) {
        this.isTrueText = false
      }
    },
    handPreview1(file) {
      // console.log(file)
      this.coverUrl1 = file.url || file.thumbUrl
      this.previewVisible = true
    },
    handCancel1() {
      this.previewVisible = false
    },
    // 上传2
    handChange2({ fileList }) {
      this.fileList2 = fileList
      // console.log(this.fileList2)
      this.coverUrl2 = fileList[0].response.url
      this.picture2.identityType = 1
      this.picture2.identityUrl = this.coverUrl2
      if (fileList[0].status == 'done') {
        let url =
          process.env.VUE_APP_API_BASE_URL +
          '/dfs/download?fileName=' +
          fileList[0].response.url +
          '&token=' +
          Vue.ls.get(ACCESS_TOKEN)
        idCardOrc({ identityUrl: url, identityType: 1 }).then(res => {
          console.log(res)
          let arr = []
          arr[0] = res.data.issuingDate.slice(0, 4)
          arr[1] = res.data.issuingDate.slice(4, 6)
          arr[2] = res.data.issuingDate.slice(-2)
          let str1 = arr.join('-')
          let arr1 = []
          arr1[0] = res.data.expiryDate.slice(0, 4)
          arr1[1] = res.data.expiryDate.slice(4, 6)
          arr1[2] = res.data.expiryDate.slice(-2)
          let str2 = arr1.join('-')
          if (res.data.riskType != 'unknown') {
            this.idStartTime = str1
            this.idEndTime = str2
            this.form.setFieldsValue({
              time: [moment(this.idStartTime), moment(this.idEndTime)]
            })
            this.isTrueTime = true
          }
        })
      }
      if (fileList.length == 0) {
        this.isTrueTime = false
      }
    },
    handPreview2(file) {
      // console.log(file)
      this.coverUrl2 = file.url || file.thumbUrl
      this.previewVisible = true
    },
    handCancel2() {
      this.previewVisible = false
    },
    // 上传3
    handChange3({ fileList }) {
      this.fileList3 = fileList
      console.log(this.fileList3)
      this.coverUrl3 = fileList[0].response.url
      this.picture3.identityType = 2
      this.picture3.identityUrl = this.coverUrl3
    },
    handPreview3(file) {
      // console.log(file)
      this.coverUrl3 = file.url || file.thumbUrl
      this.previewVisible = true
    },
    handCancel3() {
      this.previewVisible = false
    },
    // 提交
    handleSubmit(e) {
      e.preventDefault()
      this.form.validateFields((err, values) => {
        let tempInstalTypes = []
        for (let installTypeIndex in values['installType']) {
          let installType = values['installType'][installTypeIndex]
          console.log('服务列表', installType)
          for (let val in values) {
            const index = val.indexOf('$' + installType)
            if (index !== -1) {
              const tempValName = val.substr(0, index)
              console.log(tempValName)
              let obj = {}
              obj['code'] = installType
              obj[tempValName] = values[val]
              tempInstalTypes.push(obj)
              // console.log(tempInstalTypes)
              //values['installType']['installType'][installTypeIndex][tempValName] = values[val]
              delete values[val]
            }
          }
        }
        this.identity = []
        values['installType'] = tempInstalTypes
        console.log('服務列表', values['installType'])
        this.identity.push(this.picture1, this.picture2, this.picture3)
        if (!err) {
          this.iconLoading = true
          console.log('Received values of form: ', values)
          values.idStartTime = this.idStartTime
          values.idEndTime = this.idEndTime
          values.identity = this.identity
          delete values.tiem1
          console.log(values)
          addMaster(values)
            .then(res => {
              if (res.code === 0) {
                this.$message.success('保存成功')
                this.$emit('ok', 1)
                this.visible = false
              } else {
                this.$message.success(res.msg)
              }
            })
            .catch(() => {
              this.$message.error('系统错误，请稍后再试')
            })
            .finally(() => {
              this.iconLoading = false
            })
        }
      })
    },
    handleClose() {
      this.getClose()
    },
    getClose() {
      this.visible = false
      this.fileList1 = []
      this.fileList2 = []
      this.fileList3 = []
      this.picture1 = {
        identityType: '',
        identityUrl: ''
      }
      this.picture2 = {
        identityType: '',
        identityUrl: ''
      }
      this.picture3 = {
        identityType: '',
        identityUrl: ''
      }
    }
  }
}
</script>

<style scoped>
.ant-row {
  margin-top: 10px;
}

/deep/ .redItem .ant-form-item-label label {
  color: red;
}

.redItem .ant-checkbox-wrapper {
  color: red;
}

/deep/ .ant-table th {
  white-space: nowrap;
}

/deep/ .ant-table td {
  padding: 4px 16px;
}
</style>
